import { render, staticRenderFns } from "./DispatchSearch_List.vue?vue&type=template&id=7645db9c&"
import script from "./DispatchSearch_List.vue?vue&type=script&lang=js&"
export * from "./DispatchSearch_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports